import Vue from 'vue'
import Router from 'vue-router'
import LexueContainer from '@/components/LexueContainer'
import LexueContainer2 from '@/components/LexueContainer2'
import ProjectModelManager from '@/components/resource/ProjectModelManager'
import EngineHome from '@/components/teaching/engine/EngineHome'
import EngineDisassemblyTools from '@/components/teaching/engine/EngineDisassemblyTools'
import EngineProcessLine from '@/components/teaching/engine/EngineProcessLine'
import CylinderHome from '@/components/teaching/cylinder/CylinderHome'
import CylinderDisassemblyTools from '@/components/teaching/cylinder/CylinderDisassemblyTools'
import CylinderProcessLine from '@/components/teaching/cylinder/CylinderProcessLine'
import CrankshaftHome from '@/components/teaching/crankshaft/CrankshaftHome'
import CrankshaftDisassemblyTools from '@/components/teaching/crankshaft/CrankshaftDisassemblyTools'
import CrankshaftProcessLine from '@/components/teaching/crankshaft/CrankshaftProcessLine'
import SynchronizeHome from '@/components/teaching/synchronize/SynchronizeHome'
import SynchronizeDisassemblyTools from '@/components/teaching/synchronize/SynchronizeDisassemblyTools'
import SynchronizeProcessLine from '@/components/teaching/synchronize/SynchronizeProcessLine'
import EngineTrainingRecord from '@/components/training/EngineTrainingRecord'
import CylinderTrainingRecord from '@/components/training/CylinderTrainingRecord'
import CrankshaftTrainingRecord from '@/components/training/CrankshaftTrainingRecord'
import SynchronizeTrainingRecord from '@/components/training/SynchronizeTrainingRecord'
import EngineTrainingSetting from '@/components/training/EngineTrainingSetting'
import CylinderTrainingSetting from '@/components/training/CylinderTrainingSetting'
import CrankshaftTrainingSetting from '@/components/training/CrankshaftTrainingSetting'
import SynchronizeTrainingSetting from '@/components/training/SynchronizeTrainingSetting'
import MeasuringToolManager from '@/components/resource/MeasuringToolManager'

import EngineManager from '@/components/check/EngineManager'
import CylinderlManager from '@/components/check/CylinderlManager'
import CrankshaftManager from '@/components/check/CrankshaftManager'
import TransmissionManager from '@/components/check/TransmissionManager'

import CheckSetting from '@/components/check/CheckSetting'
import CheckDetails from '@/components/check/CheckDetails'
Vue.use(Router)

export default new Router({
  routes: [
    // { path: '/', name: 'Root', component: Login, hidden: true },
    // { path: '/login', name: 'Login', component: Login, hidden: true },
    {
      path: '/home',
      name: 'home',
      component: LexueContainer,
      hidden: true,
      meta: { requireAuth: true },
      redirect: '/home/teaching/engine/teachingIntro',
      children: [
        {
          path: 'resource',
          name: 'ResourceManager',
          component: LexueContainer2,
          hidden: true,
          meta: { requireAuth: true },
          redirect: 'resource/projectModel',
          children: [
            { path: 'projectModel', component: ProjectModelManager, name: 'ProjectModelManager' },
            { path: 'measuringToolManager', component: MeasuringToolManager, name: 'MeasuringToolManager' }
          ]
        },
        {
          path: 'check',
          name: 'CheckManager',
          component: LexueContainer2,
          hidden: true,
          meta: { requireAuth: true },
          redirect: 'check/engineManager',
          children: [
            { path: 'engineManager', component: EngineManager, name: 'CheckEngineManager' },
            { path: 'cylinderlManager', component: CylinderlManager, name: 'CylinderlManager' },
            { path: 'crankshaftlManager', component: CrankshaftManager, name: 'CrankshaftManager' },
            { path: 'transmissionManager', component: TransmissionManager, name: 'TransmissionManager' },
            { path: 'checkSetting', component: CheckSetting, name: 'CheckSetting' },
            { path: 'checkDetails', component: CheckDetails, name: 'CheckDetails' }
          ]
        },
        {
          path: 'teaching',
          name: 'TeachingManager',
          component: LexueContainer2,
          hidden: true,
          meta: { requireAuth: true },
          redirect: 'teaching/engine/teachingIntro',
          children: [
            {
              path: 'engine',
              name: 'EngineManager',
              component: LexueContainer2,
              hidden: true,
              meta: { requireAuth: true },
              redirect: 'engine/teachingIntro',
              children: [
                {path: 'teachingIntro', component: EngineHome, name: 'EngineHome'},
                {path: 'engineDisassemblyTools', component: EngineDisassemblyTools, name: 'EngineDisassemblyTools'},
                {path: 'engineProcessLine', component: EngineProcessLine, name: 'EngineProcessLine'}
              ]
            },
            {
              path: 'cylinder',
              name: 'CylinderManager',
              component: LexueContainer2,
              hidden: true,
              meta: { requireAuth: true },
              redirect: 'cylinder/cylinderHome',
              children: [
                {path: 'cylinderHome', component: CylinderHome, name: 'CylinderHome'
                },
                {path: 'cylinderDisassemblyTools', component: CylinderDisassemblyTools, name: 'CylinderDisassemblyTools'
                },
                {path: 'cylinderProcessLine', component: CylinderProcessLine, name: 'CylinderProcessLine'
                }
              ]
            },
            {
              path: 'crankshaft',
              name: 'CrankshaftManager2',
              component: LexueContainer2,
              hidden: true,
              meta: { requireAuth: true },
              redirect: 'crankshaft/crankshaftHome',
              children: [
                {path: 'crankshaftHome', component: CrankshaftHome, name: 'CrankshaftHome'
                },
                {path: 'crankshaftDisassemblyTools', component: CrankshaftDisassemblyTools, name: 'CrankshaftDisassemblyTools'
                },
                {path: 'crankshaftProcessLine', component: CrankshaftProcessLine, name: 'CrankshaftProcessLine'
                }
              ]
            },
            {
              path: 'synchronize',
              name: 'SynchronizeManager',
              component: LexueContainer2,
              hidden: true,
              meta: { requireAuth: true },
              redirect: 'synchronize/synchronizeHome',
              children: [
                {path: 'synchronizeHome', component: SynchronizeHome, name: 'SynchronizeHome'
                },
                {path: 'synchronizeDisassemblyTools', component: SynchronizeDisassemblyTools, name: 'SynchronizeDisassemblyTools'
                },
                {path: 'synchronizeProcessLine', component: SynchronizeProcessLine, name: 'SynchronizeProcessLine'
                }
              ]
            }
          ]
        },
        {
          path: 'training',
          name: 'TrainingManager',
          component: LexueContainer2,
          hidden: true,
          meta: { requireAuth: true },
          redirect: 'training/engineTraining',
          children: [
            {path: 'engineTraining', component: EngineTrainingRecord, name: 'EngineTrainingRecord'},
            {path: 'cylinderTraining', component: CylinderTrainingRecord, name: 'CylinderTrainingRecord'},
            {path: 'crankshaftTraining', component: CrankshaftTrainingRecord, name: 'CrankshaftTrainingRecord'},
            {path: 'synchronizeTraining', component: SynchronizeTrainingRecord, name: 'SynchronizeTrainingRecord'},
            {path: 'engineTrainingSetting', component: EngineTrainingSetting, name: 'EngineTrainingSetting'},
            {path: 'cylinderTrainingSetting', component: CylinderTrainingSetting, name: 'CylinderTrainingSetting'},
            {path: 'crankshaftTrainingSetting', component: CrankshaftTrainingSetting, name: 'CrankshaftTrainingSetting'},
            {path: 'synchronizeTrainingSetting', component: SynchronizeTrainingSetting, name: 'SynchronizeTrainingSetting'}
          ]
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js